module.exports = __webpack_public_path__ + "media/assets/facebook-674aab05dcade918ee3f71714e64638f.svg";